var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBoba(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.015 2.255a1.078 1.078 0 0 1 2.127-.353l3.107 18.734a1.078 1.078 0 1 1-2.129.353L7.016 2.254zm2.141 14.978a8.882 8.882 0 1 0 2.444-2.475l.343 2.067a7.034 7.034 0 1 1-2.232 3.754l-.555-3.346zm8.447 2.06a1.18 1.18 0 1 0 0-2.361 1.18 1.18 0 0 0 0 2.362zm-3.8 1.438a1.18 1.18 0 1 0 0-2.36 1.18 1.18 0 0 0 0 2.361zm4.16 1.388a1.18 1.18 0 1 1-2.362 0 1.18 1.18 0 0 1 2.363 0zm2.618-.052a1.18 1.18 0 1 0 .001-2.362 1.18 1.18 0 0 0 .001 2.362zm.36 2.721a1.18 1.18 0 1 1-2.361 0 1.18 1.18 0 0 1 2.36 0zm-4.877 2.62a1.18 1.18 0 1 0 0-2.363 1.18 1.18 0 0 0 0 2.362zm-1.797-3.955a1.18 1.18 0 1 1-2.362 0 1.18 1.18 0 0 1 2.362 0z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoba);
export default __webpack_public_path__ + "static/media/BOBA.da16924a9aa6b330301f0b8c21438032.svg";
export { ForwardRef as ReactComponent };